import * as React from 'react';
import AppBadges from './AppBadges';
import { CONTENT_MAX_WIDTH } from './constants';
import { Link } from '@reach/router';

interface Props {
  contentMaxWidth?: string;
}

export default function Jumbotron({
  contentMaxWidth = CONTENT_MAX_WIDTH,
}: Props) {
  return (
    <div className="w-100 h-auto flex justify-around white">
      <div
        className="w-100 pt5 pb6 relative"
        style={{
          backgroundColor: '#00384d',
          backgroundImage: `linear-gradient(to bottom, rgb(17, 67, 86), rgb(45, 100, 130))`,
        }}
      >
        <div
          className="flex flex-column-l center"
          style={{ maxWidth: contentMaxWidth }}
        >
          <div
            className="w-100 flex flex-column items-center flex-row-l"
            style={{ justifyContent: 'space-evenly' }}
          >
            <div className="w-50-l w-40 w-30-m mw5 mb5">
              <img
                className="w-100"
                src={require('../../../../assets/img/Daniel_Profile_Tilt.png')}
              />
            </div>

            <div className="tl ph4 pb4 pt0-l">
              <h3 className="ma0 pb4 fw1 f2-5 f2-l">
                Create your own virtual business card today
              </h3>
              <p className="ma0 mw6 lh-copy mb4 fw1">
                Choose the information you want to share and never worry about
                running out of business cards again. Your virtual card will
                never disappear nor end up in a trash can. Zero waste and always
                up to date!
              </p>
              {AppBadges()}
              <div className="dib mt2">
                <Link
                  to="/register"
                  className="dib white f5 pv2 pointer mb3"
                  children="Try now without the app"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
